// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { displayThresholds, themeColor } from './theme'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  theme: {
    defaultTheme: 'aura', // ให้ defualt theme เป็น aura
    themes: {
      aura: {
        colors: themeColor.aura,
      },
      xpress: {
        colors: themeColor.xpress,
      },
    },
  },
  display: {
    thresholds: displayThresholds.thresholds,
  },
})
